<!-- ========================================== -->
<!-- 修正日時: 2026-01-26 -->
<!-- 修正内容: TelDetailTableとPresenceDetailTableのマージ -->
<!--           注意: このファイルは後方互換性のため保持されています -->
<!--           メイン機能はPresenceDetailTableに統合されました -->
<!--           RealTimeTelMain.vueでの使用と、電話モード直接アクセス用に残してあります -->
<!-- ========================================== -->
<template>
  <el-row>
    <!-- 监听内容文本展示dialog -->
    <el-dialog :visible.sync="dialogVisible" width="30%" :close-on-press-escape="false" :close-on-click-modal="false"
      :before-close="handleClose" class="tel_dailog">
      <template slot="title">
        <el-row>
          <span v-if="
            $root.telRealTimeTableData[index] &&
            $root.telRealTimeTableData[index].time
          ">{{ dialogTitle }} {{ $root.htmlConst.cons_137_call_time }}
            {{ $root.telRealTimeTableData[index].time }}</span>
          <span v-else style="min-width: 185px; float: left">{{ dialogTitle }} {{ $root.htmlConst.cons_136_stop }}
          </span>
        </el-row>
        <hr style="color: #f8f8f8; opacity: 0.5" />
        <el-row class="tel-search-input">
          <el-input v-if="search != oldSearch" v-model="search" size="mini"
            :placeholder="$root.htmlConst.cons_140_input" clearable @keyup.enter.native="searchAllText('search')"
            style="width: 80%"></el-input>
          <el-input v-else v-model="search" size="mini" :placeholder="$root.htmlConst.cons_140_input" clearable
            @keyup.enter.native="downSelect()" style="width: 80%"></el-input>
          <el-button v-if="multipleSelection.length" type="info" @click="upSelect" icon="el-icon-caret-top"
            style="margin-left: 1%"></el-button>
          <el-button v-else type="info" @click="upSelect" icon="el-icon-caret-top" style="margin-left: 1%"
            disabled></el-button>
          <span v-if="search != '' && multipleSelection.length" style="padding: 0 1%">{{ searchIndex }}/{{
            multipleSelection.length }}</span>
          <span v-else-if="search != '' && multipleSelection.length == 0" style="padding: 0 1%">0/0</span>
          <el-button v-if="multipleSelection.length" type="info" @click="downSelect"
            icon="el-icon-caret-bottom"></el-button>
          <el-button v-else type="info" @click="downSelect" icon="el-icon-caret-bottom" disabled></el-button>
        </el-row>
      </template>
      <section class="result-content">
        <el-table :data="allTextData" ref="multipleTable" :show-header="false" v-loading="loading"
          :element-loading-text="$root.htmlConst.cons_141_data_loading" element-loading-spinner="el-icon-loading"
          highlight-current-row v-chat-scroll>
          <template slot="empty">
            <p>{{ emptyText }}</p>
          </template>
          <el-table-column>
            <template slot-scope="scope">
              <div class="message_msg" :class="{
                left: scope.row.flag == 'left',
                right: scope.row.flag == 'right',
              }">
                <div class="user_headshot">
                  <img :src="scope.row.opLogo != '' ? scope.row.opLogo : require('../../assets/operator.png')"
                    v-if="scope.row.user == 'オペレーター'" />
                  <img src="../../assets/watson.gif" v-else-if="scope.row.user == 'Watson'" />
                  <img
                    :src="scope.row.customerLogo != '' ? scope.row.customerLogo : require('../../assets/user_logo.png')"
                    v-else-if="scope.row.user == 'お問い合わせ者'"
                    :class="{ 'transformDefaultUserLogo': scope.row.customerLogo == '' }" />
                </div>
                <div class="user_msg">
                  <div class="speaker" v-if="scope.row.username != ''">{{ scope.row.username }}</div>
                  <div class="speaker" v-else>{{ scope.row.user }}</div>
                  <div class="user_text" v-html="scope.row.text"></div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </section>
    </el-dialog>
    <!-- 没有已经处于监听中的通话，确认是否真的要开始监听 -->
    <el-dialog :title="$root.htmlConst.cons_145_title_voice" :visible.sync="confirmDialogVisible" width="30%"
      class="tel_dailog">
      <!-- ボイスモニタリングを開始しますか？ -->
      <span style="margin: 20px 0 30px 30px; float: left; width: 100%">
        {{ $root.htmlConst.cons_142_start_voice }}
      </span>
      <span slot="footer" class="dialog-footer">
        <!-- 确认 -->
        <el-button class="is-red" type="primary" @click="startMonitoring">
          {{ $root.htmlConst.cons_143_button_ok }}
        </el-button>
        <!-- 取消 -->
        <el-button class="is-blue" type="primary" @click="confirmDialogVisible = false" plain>
          {{ $root.htmlConst.cons_144_button_cancel }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 有已经处于监听中的通话，但不是当前行，确认是否真的要停止既存的监听，开始新的监听 -->
    <el-dialog :title="$root.htmlConst.cons_145_title_voice" :visible.sync="startNewMonitoringConfirmDialogVisible"
      width="30%" class="tel_dailog">
      <!-- 現在他の通話をモニタリング中です、このモニタリングを終了して、新しいモニタリングを開始しますか？ -->
      <div style="margin: 20px 30px;">
        {{ $root.htmlConst.cons_309_tel_detail_dialog }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确认 -->
        <el-button class="is-red" type="primary" @click="startNewMonitoring">
          {{ $root.htmlConst.cons_143_button_ok }}
        </el-button>
        <!-- 取消 -->
        <el-button class="is-blue" type="primary" @click="startNewMonitoringConfirmDialogVisible = false" plain>
          {{ $root.htmlConst.cons_144_button_cancel }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 発生中の電話応対 -->
    <el-table v-if="$root.telTable" :data="$root.telRealTimeTableData" v-loading="realTimeloading"
      :element-loading-text="$root.htmlConst.cons_141_data_loading" element-loading-spinner="el-icon-loading" border
      stripe :height="$root.telTableHeight" style="overflow-y: hidden" class="detail-table tel-table"
      :header-cell-style="{ padding: '5px 0px' }">
      <!-- 発生中の電話応対没有数据时的默认展示文本 -->
      <template slot="empty">
        <p>{{ emptyText }}</p>
      </template>
      <!-- グループ -->
      <el-table-column key="2" prop="groupName" :label="$root.htmlConst.cons_113_table_header_group" style="float: left"
        :filters="$root.telRealTimeGroupFilters" :filter-method="filterGroup" filter-placement="bottom-end" width="90"
        :resizable="false">
      </el-table-column>
      <!-- 内線番号 -->
      <el-table-column key="19" prop="queueNum" :label="$root.htmlConst.cons_114_table_header_num" style="float: left"
        width="80" :resizable="false">
      </el-table-column>
      <!-- エージェント -->
      <el-table-column key="3" prop="operatorName" :label="$root.htmlConst.cons_115_table_header_user"
        style="float: left" width="100" :resizable="false">
      </el-table-column>
      <!-- SVフィルター -->
      <el-table-column key="20" prop="role" :label="$root.htmlConst.cons_116_table_header_sv"
        :filters="$root.telRealTimeSvFilters" :filter-method="filterSV" filter-placement="bottom-end" width="60"
        :resizable="false">
      </el-table-column>
      <!-- ステータスフィルター -->
      <el-table-column key="4" :label="$root.htmlConst.cons_118_table_header_access"
        :filters="$root.telRealTimeStatusFilters" :filter-method="filterStatus" filter-placement="bottom-end"
        width="140" :resizable="false">
        <template slot-scope="scope">
          <span v-if="scope.row.presence == $root.htmlConst.cons_162_status_out"
            style="background-color: #28a745; color: #fff">{{ scope.row.presence }}</span>
          <span v-else-if="
            scope.row.presence === $root.htmlConst.cons_163_status_in && !scope.row.isChanspy
          " style="background-color: #67c23a; color: #fff">{{ scope.row.presence }}</span>
          <span v-else-if="scope.row.presence === $root.htmlConst.cons_163_status_in && scope.row.isChanspy"
            style="background-color: #67c23a; color: #fff">{{ 'INモニタリング中' }}</span>
          <span v-else-if="
            scope.row.presence === $root.htmlConst.cons_165_status_online
          " style="background-color: #007bff; color: #fff">{{ scope.row.presence }}</span>
          <span v-else-if="
            scope.row.presence === $root.htmlConst.cons_166_status_busy
          " style="background-color: #ffc107">{{ scope.row.presence }}</span>
          <span v-else-if="
            scope.row.presence === $root.htmlConst.cons_167_status_away
          " style="background-color: #dddddd">{{ scope.row.presence }}</span>
          <span v-else-if="
            scope.row.presence === $root.htmlConst.cons_168_status_offline
          " style="background-color: #888888; color: #fff">
            {{ scope.row.presence }}</span>
        </template>
      </el-table-column>
      <!-- SVヘルプ -->
      <el-table-column key="21" prop="svHelp" :label="$root.htmlConst.cons_122_table_header_help" :resizable="false">
        <!-- 依頼 -->
        <el-table-column key="99" :label="$root.htmlConst.cons_122_table_header_dependent" :resizable="false">
          <template slot-scope="scope">
            <div
              :style="{ 'background-color': scope.row.svhelpStatus == 'onSupport' ? '#dcc9f4' : '#dcc9f4', color: scope.row.svhelpStatus == 'onSupport' ? '#000' : '' }">
              <span>{{ scope.row.svhelpRequestCount }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- サポート -->
        <el-table-column key="98" width="140" :label="$root.htmlConst.cons_122_table_header_support" :resizable="false">
          <template slot-scope="scope">
            <el-button class="sup_btn" type="primary"
              v-if="scope.row.svhelpStatus == 'request' && $root.user.role === 'supervisor' && scope.row.svhelpStatus != 'onSupport'"
              icon="el-icon-s-custom" @click="svHelpClick(scope.row)">サポート必要</el-button>
            <el-tooltip placement="top" v-if="scope.row.svhelpStatus == 'onSupport'">
              <div slot="content">{{ scope.row.svhelperString }}</div>
              <el-button class="sup_btn" plain v-if="scope.row.svhelpStatus == 'onSupport' &&
                ((scope.row.svhelperString.split(',')[scope.row.svhelpRequestCount - 1].replace(/\s+/g, '') == $root.user.name.replace(/\s+/g, ''))
                  || scope.row.svhelpRequestCount == '' || scope.row.svhelpRequestCount == 0)"
                @click="resetSvHelpClick(scope.row)"> <img :src="sup_icon1" alt=""> サポート中</el-button>
              <el-button class="sup_btn" plain
                v-if="scope.row.svhelpStatus == 'onSupport' && scope.row.svhelpRequestCount > 0 &&
                  scope.row.svhelperString.split(',')[scope.row.svhelpRequestCount - 1].replace(/\s+/g, '') != $root.user.name.replace(/\s+/g, '')"
                disabled> <img :src="sup_icon1" alt=""> サポート中</el-button>
            </el-tooltip>
            <el-button class="sup_btn" type="primary" v-if="scope.row.svhelpStatus == '' && scope.row.role === ''"
              icon="el-icon-s-custom"
              style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop">サポート不要</el-button>
            <el-button class="sup_btn" type="primary"
              v-if="scope.row.svhelpStatus == 'request' && $root.user.role === 'operator'" icon="el-icon-s-custom"
              style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop">サポート必要</el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- モニタリング（OP） -->
      <el-table-column :label="$root.htmlConst.cons_119_table_header_monitor" :resizable="false"
        v-if="$root.user.role === 'operator'">
        <!-- ボイス -->
        <el-table-column key="5" :resizable="false" :label="$root.htmlConst.cons_120_table_header_voice">
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.monitoring === true">
              <div slot="content">{{ scope.row.monitorName }}</div>
              <el-button type="primary" v-if="scope.row.monitoring === true" icon="el-icon-phone-outline"
                disabled></el-button>
            </el-tooltip>
            <el-button type="primary" v-else-if="scope.row.monitoring === false" icon="el-icon-phone"
              style="background-color: #bbb; border-color: #bbb" disabled></el-button>
          </template>
        </el-table-column>
        <!-- テキスト -->
        <el-table-column key="6" :resizable="false" :label="$root.htmlConst.cons_121_table_header_text">
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.hasSVNameFlag === true">
              <div slot="content">{{ scope.row.svName }}</div>
              <el-button type="primary" v-if="scope.row.hasSVNameFlag === true" icon="el-icon-document"
                disabled></el-button>
            </el-tooltip>
            <el-button type="primary" v-else-if="scope.row.hasSVNameFlag === false" icon="el-icon-document"
              style="background-color: #bbb; border-color: #bbb" disabled></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- モニタリング（SV） -->
      <el-table-column key="5" :label="$root.htmlConst.cons_119_table_header_monitor" :resizable="false" v-else>
        <!-- ボイス -->
        <el-table-column :label="$root.htmlConst.cons_120_table_header_voice">
          <template slot-scope="scope">
            <!-- 监听按钮 - 监听中 -->
            <el-tooltip placement="top" v-if="scope.row.monitoring === true">
              <div slot="content">{{ scope.row.monitorName }}</div>
              <el-button type="primary" v-if="scope.row.monitoring === true" icon="el-icon-phone-outline"
                @click="handleStartMonitoringClick(scope.row)" class="tel-monitoring"
                :disabled="userInCall"></el-button>
            </el-tooltip>
            <!-- 监听按钮 - 未监听 -->
            <el-button type="primary" v-else-if="scope.row.monitoring === false" icon="el-icon-phone"
              @click="handleStartMonitoringClick(scope.row)" :disabled="userInCall"></el-button>
            <el-button type="primary" v-else-if="
              (scope.row.presence === $root.htmlConst.cons_163_status_in ||
                scope.row.presence == $root.htmlConst.cons_163_status_out) &&
              scope.row.model != $root.htmlConst.cons_182_mode_tel
            " icon="el-icon-phone" style="background-color: #bbb; border-color: #bbb" disabled></el-button>
            <!-- 取消监听按钮 -->
            <el-tooltip placement="top" v-if="scope.row.monitoring === true && checkUserMonitor(scope.row)">
              <div slot="content">モニタリングを終了</div>
              <el-button type="danger" v-if="scope.row.monitoring === true && checkUserMonitor(scope.row)"
                icon="el-icon-phone" @click="endMonitoring(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- テキスト -->
        <el-table-column key="6" :label="$root.htmlConst.cons_121_table_header_text">
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.hasSVNameFlag === true">
              <div slot="content">{{ scope.row.svName }}</div>
              <el-button type="primary" v-if="scope.row.hasSVNameFlag === true" icon="el-icon-document"
                @click="viewAllText(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <el-button type="primary" v-else-if="scope.row.hasSVNameFlag === false" icon="el-icon-document"
              @click="viewAllText(scope.$index, scope.row)"
              style="background-color: #409eff; border-color: #409eff"></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 評価ワード発生回数 -->
      <el-table-column key="27" :label="$root.htmlConst.cons_152_table_header_word_count" :resizable="false">
        <!-- Wowワード -->
        <el-table-column key="28" :label="$root.htmlConst.cons_151_table_header_wowword" :resizable="false">
          <!-- Customer -->
          <el-table-column key="23" :label="$root.htmlConst.cons_124_table_header_questioner" :resizable="false">
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.telQuestionerWowFlg === 'true'">
                <div slot="content">
                  {{ scope.row.telQuestionerWowWords }}
                </div>
                <div style="
                    background-color: #67c23a;
                    color: #000;
                    float: left;
                    width: 100%;
                  " v-if="scope.row.telQuestionerWowFlg === 'true'">
                  <span>{{ scope.row.telQuestionerWowWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.telQuestionerWowWordCount }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- Agent -->
          <el-table-column key="39" :label="$root.htmlConst.cons_125_table_header_operator">
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.telOperatorWowWordFlg === 'true'">
                <div slot="content">{{ scope.row.telOperatorWowWords }}</div>
                <div style="
                    background-color: #67c23a;
                    color: #000;
                    float: left;
                    width: 100%;
                  " v-if="scope.row.telOperatorWowWordFlg === 'true'">
                  <span>{{ scope.row.telOperatorWowWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.telOperatorWowWordCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- NGワード -->
        <el-table-column key="26" :label="$root.htmlConst.cons_126_table_header_ngword" :resizable="false">
          <!-- Customer -->
          <el-table-column key="10" :label="$root.htmlConst.cons_124_table_header_questioner" :resizable="false">
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.telQuestionerNgFlg === 'true'">
                <div slot="content">{{ scope.row.telQuestionerNgWords }}</div>
                <div style="
                    background-color: #ffc107;
                    color: #000;
                    float: left;
                    width: 100%;
                  " v-if="scope.row.telQuestionerNgFlg === 'true'">
                  <span>{{ scope.row.telQuestionerNgWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.telQuestionerNgWordCount }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- Agent -->
          <el-table-column key="11" :label="$root.htmlConst.cons_125_table_header_operator" :resizable="false">
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.telOperatorNgFlg === 'true'">
                <div slot="content">
                  {{ scope.row.telOperatorNgWords }}
                </div>
                <div style="
                    background-color: #ffc107;
                    color: #000;
                    float: left;
                    width: 100%;
                  " v-if="scope.row.telOperatorNgFlg === 'true'">
                  <span>{{ scope.row.telOperatorNgWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.telOperatorNgWordCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- NGマナー -->
        <el-table-column key="25" :label="$root.htmlConst.cons_150_table_header_ngmanner" :resizable="false">
          <!-- Agent -->
          <el-table-column key="24" :label="$root.htmlConst.cons_125_table_header_operator">
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.telOperatorNgMannerFlg === 'true'">
                <div slot="content">{{ scope.row.telOperatorNgManners }}</div>
                <div style="
                    background-color: #ffc107;
                    color: #000;
                    float: left;
                    width: 100%;
                  " v-if="scope.row.telOperatorNgMannerFlg === 'true'">
                  <span>{{ scope.row.telOperatorNgMannerCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.telOperatorNgMannerCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <!-- 応対時間（分） -->
      <el-table-column key="13" :label="$root.htmlConst.cons_130_table_header_time" :resizable="false">
        <template slot-scope="scope">
          <div class="alert-long-time" v-if="scope.row.longTimeFlg === 'true'">
            <span>{{ scope.row.time }}</span>
          </div>
          <div v-else>
            <span>{{ scope.row.time }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 日次集計データ -->
    <el-table v-else :data="$root.telDailyTableData" v-loading="dailyLoading"
      :element-loading-text="$root.htmlConst.cons_141_data_loading" element-loading-spinner="el-icon-loading" border
      stripe :height="$root.telTableHeight" style="overflow-y: hidden" class="detail-table tel-table"
      :header-cell-style="{ padding: '5px 0px' }">
      <!-- 日次集計データ没有数据时的默认展示文本 -->
      <template slot="empty">
        <p>{{ emptyText }}</p>
      </template>
      <!-- グループ -->
      <el-table-column key="2" prop="groupName" :label="$root.htmlConst.cons_113_table_header_group" style="float: left"
        :filters="$root.telDailyGroupFilters" :filter-method="filterGroup" filter-placement="bottom-end" width="90"
        :resizable="false">
      </el-table-column>
      <!-- 内線番号 -->
      <el-table-column key="19" prop="queueNum" :label="$root.htmlConst.cons_114_table_header_num" style="float: left"
        width="110" :resizable="false">
      </el-table-column>
      <!-- エージェント -->
      <el-table-column key="3" prop="operatorName" :label="$root.htmlConst.cons_115_table_header_user"
        style="float: left" width="110" :resizable="false">
      </el-table-column>
      <!-- SV -->
      <el-table-column key="20" prop="role" :label="$root.htmlConst.cons_116_table_header_sv"
        :filters="$root.telDailySvFilters" :filter-method="filterSV" filter-placement="bottom-end" width="60"
        :resizable="false">
      </el-table-column>
      <!-- 応対件数 -->
      <el-table-column key="68" prop="telDailyCount" :label="$root.htmlConst.cons_131_table_header_count"
        :resizable="false">
      </el-table-column>
      <!-- 応対時間（分） -->
      <el-table-column :label="$root.htmlConst.cons_132_table_header_daily_time" v-if="$root.dailyTimeFlg === '1'"
        :resizable="false">
        <!-- 合計 -->
        <el-table-column key="48" :label="$root.htmlConst.cons_133_table_header_sum" prop="telDailyTime"
          :resizable="false">
        </el-table-column>
        <!-- 平均 -->
        <el-table-column key="49" :label="$root.htmlConst.cons_134_table_header_ave" prop="telDailyAverageTime"
          :resizable="false">
        </el-table-column>
      </el-table-column>
      <!-- 評価ワード発生率 -->
      <el-table-column key="50" :label="$root.htmlConst.cons_152_table_header_word_rate" :resizable="false">
        <!-- Wowワード -->
        <el-table-column key="51" :label="$root.htmlConst.cons_151_table_header_wowword" :resizable="false">
          <!-- Customer -->
          <el-table-column key="52" :label="$root.htmlConst.cons_124_table_header_questioner"
            prop="questionerWowwordRate" :resizable="false">
          </el-table-column>
          <!-- Agent -->
          <el-table-column key="68" :label="$root.htmlConst.cons_125_table_header_operator" prop="opertorWowwordRate"
            :resizable="false">
          </el-table-column>
        </el-table-column>
        <!-- NGワード -->
        <el-table-column key="53" :label="$root.htmlConst.cons_126_table_header_ngword" :resizable="false">
          <!-- Customer -->
          <el-table-column key="54" :label="$root.htmlConst.cons_124_table_header_questioner"
            prop="questionerNgwordRate" :resizable="false">
          </el-table-column>
          <!-- Agent -->
          <el-table-column key="55" :label="$root.htmlConst.cons_125_table_header_operator" prop="opertorNgwordRate"
            :resizable="false">
          </el-table-column>
        </el-table-column>
        <!-- NGマナー -->
        <el-table-column key="56" :label="$root.htmlConst.cons_150_table_header_ngmanner" :resizable="false">
          <!-- Agent -->
          <el-table-column key="57" :label="$root.htmlConst.cons_125_table_header_operator" prop="opertorNgmannarRate"
            :resizable="false">
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <!-- 平均満足度 -->
      <el-table-column :label="$root.htmlConst.cons_135_table_header_traffic"
        v-if="$root.dailySatisfactionIndex === 'display'" :resizable="false">
        <!-- Customer -->
        <el-table-column key="58" :label="$root.htmlConst.cons_124_table_header_questioner"
          prop="questionerDailyFrequency" :resizable="false">
        </el-table-column>
        <!-- Agent -->
        <el-table-column key="59" :label="$root.htmlConst.cons_125_table_header_operator" prop="operatorDailyFrequency"
          :resizable="false">
        </el-table-column>
      </el-table-column>
      <!-- 音声波形感情指数 -->
      <el-table-column v-if="$root.speechEmotionIndex === 'display'"
        :label="$root.htmlConst.cons_123_table_header_sound" :resizable="false">
        <!-- Customer -->
        <el-table-column key="7" :label="$root.htmlConst.cons_124_table_header_questioner" prop="questioner">
        </el-table-column>
        <!-- Agent -->
        <el-table-column :label="$root.htmlConst.cons_125_table_header_operator" key="8" prop="emotion1"
          :resizable="false">
        </el-table-column>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
// import data3 from './3.json'
// import data4 from './4.json'
import api from "@/api";
import { find } from "lodash";
var moment = require("moment-timezone");
var sd = require("silly-datetime");
export default {
  name: "TelDetailTable",
  data() {
    return {
      // 是否有自己已经在监听的通话
      isMonitoring: false,
      // 自己正在监听的通话
      currentRowMonitoring: {},
      // 当前点击的数据行
      currentRowClicked: {},
      // 已经有正在监听的通话但是想要监听新的通话时的确认框显示状态
      startNewMonitoringConfirmDialogVisible: false,
      sup_icon1: require('@/assets/sup_icon1.svg'),
      emptyText: "",
      lockReconnect: false,
      allTextData: [],
      dialogTitle: "",
      dialogVisible: false,
      confirmDialogVisible: false,
      conUuid: "",
      search: "",
      oldSearch: "",
      loading: this.loading,
      realTimeloading: this.realTimeloading,
      dailyLoading: false,
      dialogOperatorId: "",
      userTextInterval: "",
      timer: "",
      dialogTime: "",
      index: "",
      checkIndex: 0,
      searchIndex: 1,
      multipleSelection: [],
      isCreateThreeCallSubmit: true,
    };
  },
  created() {
    if (this.$root.user.user_id) {
      this.getTelRealTimeTableDetail();
      this.getTelDailyTableDetail();
    } else {
      api.getUserInfo().then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            this.$root.user = data.user;
            this.getTelRealTimeTableDetail();
            this.getTelDailyTableDetail();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  },
  mounted: function () {
    var _this = this;
    // ==========================================
    // 修正日時: 2026-01-22
    // 修正内容: 通話詳細テーブルの通話時間計算のタイムゾーン統一
    //           - JST手動計算とmoment().diff()を削除し、UTCベースで統一
    //           - バックエンドのcaculateTime()と同じロジックを使用
    //           - タイムゾーン差による誤差を排除
    // ==========================================
    this.timer = setInterval(function () {
      for (let data of _this.$root.telRealTimeTableData) {
        if (data.answerTime) {
          // バックエンドのcaculateTime()と同じロジックを使用（UTCで統一）
          // answerTimeはISO文字列（UTC）として受け取る
          let nowDate = new Date().getTime(); // UTC
          let answerTimeDate = new Date(data.answerTime).getTime(); // UTC（ISO文字列をパース）
          let diffTime = nowDate - answerTimeDate;

          // 時間、分、秒を計算（Math.floorを使用）
          let hours = Math.floor(diffTime / (3600 * 1000));
          let minutes = Math.floor((diffTime - hours * 3600 * 1000) / (60 * 1000));
          let seconds = Math.floor((diffTime - hours * 3600 * 1000 - minutes * 60 * 1000) / 1000);

          // フォーマット（バックエンドと同じ形式）
          let hoursStr = hours < 10 ? ("0" + hours + ":") : (hours + ":");
          let minutesStr = minutes < 10 ? ("0" + minutes + ":") : (minutes + ":");
          let secondsStr = seconds < 10 ? ("0" + seconds) : (seconds);

          data.time = hoursStr + minutesStr + secondsStr;

          // 長時間フラグの判定
          if (
            data.longTimeFlg != "true" &&
            (hours > 0 || minutes >= _this.$root.longTimeConfig)
          ) {
            data.longTimeFlg = "true";
          }
        }
      }
      _this.$root.telLongTimeCount = _this.$root.telRealTimeTableData.filter((i) => {
        return i.hasOwnProperty("longTimeFlg") && i.longTimeFlg == "true";
      }).length;
    }, 1000);
  },
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  computed: {
    userInCall() {
      if (this.$root.telRealTimeTableData) {
        for (let oneCallInfo of this.$root.telRealTimeTableData) {
          if (oneCallInfo.loginId == this.$root.user.login_id && !oneCallInfo.isChanspy) {
            return true
          }
        }
      }
      return false
    }
  },
  methods: {
    filterInOut(value, row) {
      return row.in_out === value;
    },
    filterGroup(value, row) {
      return row.groupName === value;
    },
    filterSV(value, row) {
      return row.role === value;
    },
    filterStatus(value, row) {
      return row.presence === value;
    },
    // 获取实时通话状态
    getTelRealTimeTableDetail: function () {
      this.realTimeloading = true;
      this.$root.isDataLoading = true
      api.getTelRealTimeTableDetail(this.$root.user.user_id).then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            // let data = data4
            this.$root.telRealTimeTableData = data.output_list;
            for (let groupName of data.output_list.map((v) => v.groupName)) {
              let groupNameFilter = {};
              if (
                !this.$root.telRealTimeGroupFilters
                  .map((v) => v.value)
                  .includes(groupName)
              ) {
                groupNameFilter.text = groupName;
                groupNameFilter.value = groupName;
                this.$root.telRealTimeGroupFilters.push(groupNameFilter);
              }
            }
            for (let role of data.output_list.map((v) => v.role)) {
              let svFilter = {};
              if (
                !this.$root.telRealTimeSvFilters
                  .map((v) => v.value)
                  .includes(role)
              ) {
                svFilter.text = role;
                svFilter.value = role;
                this.$root.telRealTimeSvFilters.push(svFilter);
              }
            }
            for (let presence of data.output_list.map((v) => v.presence)) {
              let statusFilter = {};
              if (
                !this.$root.telRealTimeStatusFilters
                  .map((v) => v.value)
                  .includes(presence)
              ) {
                statusFilter.text = presence;
                statusFilter.value = presence;
                this.$root.telRealTimeStatusFilters.push(statusFilter);
              }
            }
            this.$root.telNgCount = data.ngCount;
            // this.$root.telLongTimeCount = data.longTimeCount;
            this.$root.telSVDependCount = data.svDependCount;
            this.realTimeloading = false;
            this.$root.isDataLoading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getTelDailyTableDetail: function () {
      this.dailyLoading = true;
      api.getTelDailyTableDetail(this.$root.user.user_id).then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            // let data = data3
            this.$root.telDailyTableData = data.output_list;
            for (let groupName of data.output_list.map((v) => v.groupName)) {
              let groupNameFilter = {};
              if (
                !this.$root.telDailyGroupFilters
                  .map((v) => v.value)
                  .includes(groupName)
              ) {
                groupNameFilter.text = groupName;
                groupNameFilter.value = groupName;
                this.$root.telDailyGroupFilters.push(groupNameFilter);
              }
            }
            for (let role of data.output_list.map((v) => v.role)) {
              let svFilter = {};
              if (
                !this.$root.telDailySvFilters.map((v) => v.value).includes(role)
              ) {
                svFilter.text = role;
                svFilter.value = role;
                this.$root.telDailySvFilters.push(svFilter);
              }
            }
            this.dailyLoading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    // ==========================================
    // 修正日時: 2026-01-22
    // 修正内容: ボイスボットのテキストモニタリング対応
    //           - queueNum === '8899' の場合は電話番号ベースで取得
    //           - 通常オペレーターはloginIdベースで取得（既存動作）
    // ==========================================
    getUserAllText: function () {
      let _this = this;
      // ボイスボット（queueNum === '8899'）の場合は電話番号で検索
      if (_this.$root.telRealTimeTableData[_this.index] &&
        _this.$root.telRealTimeTableData[_this.index].queueNum === '8899') {
        let phoneNumber = _this.$root.telRealTimeTableData[_this.index].callerNumber;
        api.getUserAllTextByPhone(phoneNumber).then(
          (res) => {
            if (res && res.data) {
              _this.allTextData = res.data.output_list;
              _this.searchAllText("load");
              if (!_this.search) {
                _this.$refs.multipleTable.bodyWrapper.scrollTop =
                  _this.$refs.multipleTable.bodyWrapper.scrollHeight;
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      } else {
        // 通常のオペレーターはloginIdで検索
        api.getUserAllText(this.dialogOperatorId).then(
          (res) => {
            if (res && res.data) {
              _this.allTextData = res.data.output_list;
              _this.searchAllText("load");
              if (!_this.search) {
                _this.$refs.multipleTable.bodyWrapper.scrollTop =
                  _this.$refs.multipleTable.bodyWrapper.scrollHeight;
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    },
    viewAllText(index, row) {
      this.index = index;
      this.dialogVisible = true;
      this.allTextData = [];
      this.multipleSelection = [];
      let self = this;
      self.loading = true;
      this.dialogOperatorId = row.loginId;
      this.dialogTitle = row.operatorName;

      // ==========================================
      // 修正日時: 2026-01-22
      // 修正内容: ボイスボットのテキストモニタリング対応
      //           - ボイスボット（queueNum === '8899'）の場合はsaveTextStatusをスキップ
      //           - loginIdが空のため、saveTextStatus APIが不要
      // ==========================================
      if (row.queueNum === '8899') {
        self.getUserAllText();
        self.userTextInterval = window.setInterval(() => {
          setTimeout(self.getUserAllText(), 0);
        }, 5000);
        self.loading = false;
      } else {
        let data = {
          user_id: this.$root.user.user_id,
          operator_id: self.dialogOperatorId,
          svName: self.$root.user.name,
        };

        api.saveTextStatus(data).then(
          () => {
            self.getUserAllText();
            self.userTextInterval = window.setInterval(() => {
              setTimeout(self.getUserAllText(), 0);
            }, 5000);
            self.loading = false;
          },
          (err) => {
            console.log(err);
          }
        );
      }
    },
    // 检查用户是否已经监听了当前通话
    // 多个SV可以监听同一通电话
    checkUserMonitor(row) {
      let hasUserNameFlg = false;
      // 如果当前行未处于监听中，则不会有monitorName属性
      if (row.monitorName) {
        let userName = this.$root.user.name;
        let userNameArr = userName.split(' ');
        userName = userNameArr[0] + userNameArr[1];
        let monitorName = row.monitorName;
        let monitorNameArr = monitorName.split(',');
        for (let index in monitorNameArr) {
          if (monitorNameArr[index].replace(' ', '') == userName) {
            hasUserNameFlg = true;
            break;
          }
        }
      }
      return hasUserNameFlg
    },
    // 开始监听按钮点击事件
    handleStartMonitoringClick(row) {
      let isMonitoring = false;
      let currentRowMonitoring = {};
      for (let telRow of this.$root.telRealTimeTableData) {
        if (this.checkUserMonitor(telRow)) {
          // 有自己正在监听的通话
          isMonitoring = true;
          // 自己正在监听的通话
          currentRowMonitoring = telRow;
          break;
        }
      }
      if (isMonitoring) {
        // 有正在监听中的电话

        // 正在监听的通话不是当前行
        if (currentRowMonitoring.conUuid !== row.conUuid) {
          // 设置可以开始三方通话
          this.isCreateThreeCallSubmit = true;
          // 正在监听的通话是其它行
          this.startNewMonitoringConfirmDialogVisible = true;
        }

        // 正在监听的通话是当前行，不做任何处理
      } else {
        // 没有正在监听中的电话

        // 设置可以开始三方通话
        this.isCreateThreeCallSubmit = true;
        // 弹出dialog跟用户确认是否真的要开始监听
        this.confirmDialogVisible = true;
      }
      this.isMonitoring = isMonitoring;
      this.currentRowMonitoring = currentRowMonitoring;
      this.currentRowClicked = row;
    },
    // 终止旧的监听，开始新的监听
    startNewMonitoring() {
      // 终止旧的监听
      this.endMonitoring(this.currentRowMonitoring);
      // 开始新的监听
      this.startMonitoring();
      // 关闭dialog
      this.startNewMonitoringConfirmDialogVisible = false;
    },
    // 开始监听，SV加入Customer和OP的通话
    startMonitoring() {
      if (this.isCreateThreeCallSubmit) {
        this.isCreateThreeCallSubmit = false
        // ==========================================
        // 修正日時: 2026-01-23
        // 修正内容: ボイスボットのモニタリング発信先変更
        //           - ボイスボット（queueNum === '8899'）の場合は555 + 発信元番号（callerNumber）
        //           - 通常のオペレーター通話の場合は555 + queueNum（既存動作）
        // ==========================================
        let dialNum;
        if (this.currentRowClicked.queueNum === '8899' && this.currentRowClicked.callerNumber) {
          // ボイスボットの場合は発信元番号を使用
          dialNum = '555'.concat(this.currentRowClicked.callerNumber);
        } else {
          // 通常のオペレーター通話の場合はqueueNumを使用
          dialNum = '555'.concat(this.currentRowClicked.queueNum);
        }
        console.log('dialNum....', dialNum)
        
        // ソフトフォンを表示
        this.$store.dispatch('phone/setShowPhone', true)
        
        // モニタリング用の電話番号を設定（ソフトフォンに自動入力される）
        this.$store.commit('phone/setCurrentCallerNum', dialNum)
        
        // 自動通話開始フラグを設定（Phone.vueがwatchして自動的に通話を開始）
        this.$nextTick(() => {
          this.$store.commit('phone/setAutoStartMonitoringCall', true)
        })
        
        this.$store.state.startMonitoring = true
        this.confirmDialogVisible = false;
      }
    },
    // 取消监听
    endMonitoring(row) {
      // ==========================================
      // 修正日時: 2026-01-23
      // 修正内容: ボイスボットのモニタリング終了対応
      //           - ボイスボット（queueNum === '8899'）の場合は555 + 発信元番号（callerNumber）
      //           - 通常のオペレーター通話の場合は555 + queueNum（既存動作）
      //           - rowがオブジェクトの場合はqueueNumとcallerNumberを取得
      //           - rowが文字列の場合は後方互換性のためqueueNumとして扱う
      // ==========================================
      let dialNum;
      if (typeof row === 'object' && row !== null) {
        // rowオブジェクトからqueueNumとcallerNumberを取得
        if (row.queueNum === '8899' && row.callerNumber) {
          // ボイスボットの場合は発信元番号を使用
          dialNum = '555'.concat(row.callerNumber);
        } else {
          // 通常のオペレーター通話の場合はqueueNumを使用
          dialNum = '555'.concat(row.queueNum || row);
        }
      } else {
        // 後方互換性: rowが文字列（queueNum）の場合
        dialNum = '555'.concat(row);
      }
      this.$SIP.endSession(dialNum);
      this.$store.state.startMonitoring = false
    },
    handleClose() {
      let self = this;
      self.allTextData = [];
      self.search = "";
      self.oldSearch = "";
      self.multipleSelection = [];
      this.dialogVisible = false;
      clearInterval(this.userTextInterval);

      // ==========================================
      // 修正日時: 2026-01-22
      // 修正内容: ボイスボットのテキストモニタリング対応
      //           - ボイスボット（queueNum === '8899'）の場合はcloseDialogをスキップ
      //           - loginIdが空のため、closeDialog APIが不要
      // ==========================================
      if (self.$root.telRealTimeTableData[self.index] &&
        self.$root.telRealTimeTableData[self.index].queueNum === '8899') {
        return;
      }

      let data = {
        user_id: this.$root.user.user_id,
        operator_id: self.dialogOperatorId,
        svName: self.$root.user.name,
      };
      api.closeDialog(data).then(
        () => { },
        (err) => {
          console.log(err);
        }
      );
    },
    searchAllText(action) {
      if (action == "search") {
        this.searchIndex = 1;
        this.multipleSelection = [];
      }
      if (this.oldSearch) {
        for (let text of this.allTextData) {
          if (text.text.includes(this.oldSearch)) {
            text.text = text.text.replace(
              RegExp(
                '<span class="resultOn">' + this.oldSearch + "</span>",
                "g"
              ),
              this.oldSearch
            );
            text.text = text.text.replace(
              RegExp(
                '<span class="resultOff">' + this.oldSearch + "</span>",
                "g"
              ),
              this.oldSearch
            );
          }
        }
      }
      if (this.search) {
        let tmpmultipleSelection = [];
        let allCount = 0;
        for (var i = 0; i < this.allTextData.length; i++) {
          let count = 0;
          if (this.allTextData[i].text.includes(this.search)) {
            this.allTextData[i].text = this.allTextData[i].text.replace(
              RegExp(this.search, "g"),
              '<span class="resultOn">' + this.search + "</span>"
            );
            count = this.allTextData[i].text.split(this.search).length - 1;
          }
          for (var j = 1; j <= count; j++) {
            let data = {
              rowIndex: i,
              rowSearchIndex: j,
              searchIndex: allCount + j,
            };
            tmpmultipleSelection.push(data);
          }
          allCount = allCount + count;
        }
        this.multipleSelection = tmpmultipleSelection;
        if (this.multipleSelection.length > 0) {
          const item = find(this.multipleSelection, {
            searchIndex: this.searchIndex,
          });
          let rowContentList = this.allTextData[item.rowIndex].text.split(
            this.search
          );
          let newContent = "";
          for (var m = 0; m < rowContentList.length; m++) {
            if (m == item.rowSearchIndex - 1) {
              newContent =
                newContent +
                rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
            } else {
              newContent = newContent + rowContentList[m];
            }
            if (m != rowContentList.length - 1) {
              newContent = newContent + this.search;
            }
          }
          this.allTextData[item.rowIndex].text = newContent;

          this.setCurrentRow(item.rowIndex);
        }
      }
      this.oldSearch = this.search;
    },
    downSelect() {
      for (let text of this.allTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      if (this.searchIndex >= this.multipleSelection.length) {
        this.searchIndex = 1;
      } else {
        this.searchIndex += 1;
      }
      const item = find(this.multipleSelection, {
        searchIndex: this.searchIndex,
      });
      let rowContentList = this.allTextData[item.rowIndex].text.split(
        this.search
      );
      let newContent = "";
      for (var m = 0; m < rowContentList.length; m++) {
        if (m == item.rowSearchIndex - 1) {
          newContent =
            newContent +
            rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
        } else {
          newContent = newContent + rowContentList[m];
        }
        if (m != rowContentList.length - 1) {
          newContent = newContent + this.search;
        }
      }
      this.allTextData[item.rowIndex].text = newContent;
      this.setCurrentRow(item.rowIndex);
    },
    upSelect() {
      for (let text of this.allTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      if (this.searchIndex == 1) {
        this.searchIndex = this.multipleSelection.length;
      } else {
        this.searchIndex -= 1;
      }
      const item = find(this.multipleSelection, {
        searchIndex: this.searchIndex,
      });
      let rowContentList = this.allTextData[item.rowIndex].text.split(
        this.search
      );
      let newContent = "";
      for (var m = 0; m < rowContentList.length; m++) {
        if (m == item.rowSearchIndex - 1) {
          newContent =
            newContent +
            rowContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
        } else {
          newContent = newContent + rowContentList[m];
        }
        if (m != rowContentList.length - 1) {
          newContent = newContent + this.search;
        }
      }
      this.allTextData[item.rowIndex].text = newContent;
      this.setCurrentRow(item.rowIndex);
    },
    setCurrentRow(index) {
      if (this.multipleSelection.length == 0) {
        return false;
      } else {
        const targetTop = this.$refs.multipleTable.$el
          .querySelectorAll(".el-table__body tr")[index].getBoundingClientRect().top;
        const containerTop = this.$refs.multipleTable.$el
          .querySelector(".el-table__body")
          .getBoundingClientRect().top;
        const scrollParent = this.$refs.multipleTable.$el.querySelector(
          ".el-table__body-wrapper"
        );
        let scrollHeight = targetTop - containerTop;
        scrollParent.scrollTop = scrollHeight;
      }
    },
    svHelpClick(row) {
      api.svhelpOnSupport("NEXMO_ASTERISK_PBX_MODE", row.operatorId, this.$root.user.user_id, '').then(
        (res) => {
          if (res && res.data) {
            console.log("svhelpOnSupport success");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    resetSvHelpClick(row) {
      api.resetSvhelpOnSupport("NEXMO_ASTERISK_PBX_MODE", row.operatorId, this.$root.user.user_id, '').then(
        (res) => {
          if (res && res.data) {
            console.log("svhelpOnSupport reset success");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>


<style lang="scss">
.tel-search-input {
  .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
  }
}

.tel_dailog .el-dialog__header {
  background-color: #55BFE7;
  color: #FFFFFF;
}

.tel-table thead.is-group th {
  background-color: #55BFE7 !important;
}

// .detail-table .el-table__header-wrapper {
//   height: 74px;
// }
.detail-table .el-table__body-wrapper {
  height: calc(100% - 74px) !important;
}

.el-table {
  font-size: 12px;
  overflow-y: hidden;
}

.el-table th>.cell {
  text-align: center;
}

.el-table .cell {
  line-height: 20px;
}

.el-table tbody tr {
  pointer-events: auto !important;
}

.el-table td>.cell {
  text-align: center;
}

.el-table thead.is-group th {
  background-color: #0076d3;
  color: #fff;
}

.el-table_1_column_2>.cell {
  text-align: center;
  float: center;
}

.el-table_1_column_3>.cell {
  text-align: center;
  float: center;
}

.el-table_1_column_4>.cell {
  text-align: center;
  float: center;
}

.el-table td,
.el-table th {
  padding: 5px 0 5px 0;
}

.el-table .angry-row>td {
  background-color: red;
  color: #fff;
}

.el-table .happy-row>td {
  background: rgb(40, 167, 69) !important;
  color: #fff;
}

.el-table tbody tr {
  pointer-events: none;
}

.el-button {
  padding: 0;
  font-size: 13px;
}

.el-table tbody .el-button--text {
  color: #000 !important;
}

.message_msg .user_msg {
  overflow: hidden;
  max-width: 80%;
}

.message_msg .user_headshot {
  margin-top: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  float: left;
  position: relative;
  overflow: hidden;
  background-color: #fff;
}

.message_msg .user_headshot img {
  width: 100%;
  border-spacing: 50%;
}

.message_msg .speaker {
  font-size: 12px;
}

.message_msg .user_text {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 10px;
  position: relative;
  text-align: left;
}

.message_msg .user_text :before {
  content: "\2666";
  font-size: 18px;
  position: absolute;
  top: 5px;
}

.message_msg.left .user_msg {
  padding-left: 10px;
  float: left;
  text-align: left;
}

.message_msg.left .user_headshot .transformDefaultUserLogo {
  transform: scaleX(-1);
}

.message_msg.left .user_text {
  background: #ddd;
  float: left;
}

.message_msg.left .user_text :before {
  left: -5px;
  color: #ddd;
  z-index: 100;
}

.message_msg.right .user_msg {
  padding-right: 10px;
  float: right;
}

.message_msg.right .speaker {
  text-align: right;
}

.message_msg.right .user_headshot {
  float: right;
  margin-right: 10px;
}

.message_msg.right .user_text {
  background: #c6e5ff;
  float: right;
}

.message_msg.right .user_text :before {
  right: -5px;
  color: #c6e5ff;
  z-index: 100;
}

.message_msg:before,
.message_msg:after {
  content: "";
  display: table;
}

.message_msg:after {
  clear: both;
}

/* .el-dialog {
  height: 65% !important;
  min-height: 70%;
} */
.el-dialog__title {
  font-size: 14px;
}

.el-dialog__body {
  padding: 0px !important;
}

.el-input--mini {
  width: 45%;
  margin-left: 2%;
}

.el-button--text {
  color: #fffccc;
}

.el-table td,
.el-table th {
  padding: 2px 0;
}

.is-red {
  background-color: #ffd7da;
  border-color: #ffa4ab;
  color: #000;
  margin-top: 7px;
  min-width: 5.625rem;
  min-height: 45px;
}

.is-blue {
  margin-top: 7px;
  min-width: 5.625rem;
  min-height: 45px;
}

.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  border-color: #409eff;
  background: #409eff;
  color: #fff;
}

.el-button.is-red:focus,
.el-button.is-red:hover {
  color: #000;
  background-color: #ffa4ab;
  border-color: #ff717c;
}

.el-table__body-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  height: 455px;
}

.el-input--mini {
  margin-left: 0px;
}

.resultOn {
  background: yellow;
}

.resultOff {
  background: greenyellow;
}

.el-table__column-filter-trigger i {
  color: #fff !important;
}

.el-input--mini {
  margin-right: 5px;
}

.el-page-header__content {
  text-align: center;
  width: 75%;
}

.tel-monitoring {
  cursor: default;
}
.alert-long-time {
	// background-color: #996633; 
	background-color:#d5934f;;
	color: #000
}
</style>
